import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { stopEventRefs } from "../subjects/stopEvent/refs";
import { callRejectionFacts, callRejectionV2Facts } from "../subjects/stopEvent/callRejectionFacts";

/**
 * The TMS refused the call because the truck was not at the stop it named, or was not within range of it.
 */
export const notAtStopV1 = tmsEventKind(
  { category: "callRejection", kind: "notAtStop", version: 1 },
  { refs: stopEventRefs, facts: callRejectionFacts },
);

export const NotAtStopV1Schema = notAtStopV1.schema;
export const NotAtStopV1FactsSchema = notAtStopV1.facts;

export type NotAtStopV1 = z.infer<typeof NotAtStopV1Schema>;
export type NotAtStopV1Facts = z.infer<typeof NotAtStopV1FactsSchema>;

/**
 * Version 2: the same refusal, plus what the driver's call said — its type, load, trailers, consignee, and lines.
 */
export const notAtStopV2 = tmsEventKind(
  { category: "callRejection", kind: "notAtStop", version: 2 },
  { refs: stopEventRefs, facts: callRejectionV2Facts },
);

export const NotAtStopV2Schema = notAtStopV2.schema;
export const NotAtStopV2FactsSchema = notAtStopV2.facts;

export type NotAtStopV2 = z.infer<typeof NotAtStopV2Schema>;
export type NotAtStopV2Facts = z.infer<typeof NotAtStopV2FactsSchema>;

/** Every version of `notAtStop`, keyed by version. What `catalog.ts` places under `callRejection`. */
export const notAtStop = { 1: notAtStopV1, 2: notAtStopV2 } as const;
